import React, {useEffect, useState} from "react";
import {useStyles} from "../styles/Filter";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Typography} from '@deere/fuel-react';
import AccordionDetails from "@material-ui/core/AccordionDetails";

export default function FeedbackPeriodFilter({periodData, filteredData, expanded, onExpandClick, onPeriodUpdate, name}) {
    const classes = useStyles();
    const [periodList, setPeriodList] = useState([]);

    const handleChange = (event) => {
        const updatedList = periodList.map(list => {
            if (list.name === event.target.name) {
                list.checked = event.target.checked
            }
            return list
        })
        onPeriodUpdate(updatedList)
        setPeriodList(updatedList)
    };

    useEffect(() => {
        const filterListName = name === "Ratings" ? "fiscalYear" : "campPeriod";
        const updatedData = periodData.sort((a, b) => (a.fiscalYear > b.fiscalYear) ? -1 : 1)
        const list = updatedData.map(item => {
            return filteredData.includes(item[filterListName]) ? {name: item[filterListName], label: item[filterListName], checked: true} : {name: item[filterListName], label: item[filterListName], checked: false}
        })
        setPeriodList(list)
    }, [periodData, filteredData, name]);

    return (
        <div className={classes.root}>
            <Accordion expanded={expanded}
                       onChange={onExpandClick}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{content: classes.content, expanded: classes.expanded}}
                    expandIcon={<ExpandMoreIcon style={{fontSize: '2rem'}}/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>Response Period</Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.statusContent}>
                    <FormControl component="fieldset">
                        <FormGroup>
                            {periodList && periodList.map((list, index) => {
                                return (
                                    <FormControlLabel key={index} className={classes.root} onChange={handleChange}
                                                      control={<Checkbox checked={list.checked} name={list.name}/>}
                                                      label={list.label}/>
                                )
                            })}
                        </FormGroup>
                    </FormControl>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
